export default __webpack_public_path__ + "static/media/Path3479.051ecb92.svg";